import { IconButton } from 'rsuite';
import { icons } from '@shared/static/icons';

export default function ThemeButtonIcon({
  icon,
  onClick,
  isNew = false,
  appearance = 'secondary',
  as = 'button',
  href,
  target,
  disabled = false,
}) {
  return (
    <IconButton
      as={as}
      href={href}
      target={target}
      icon={icons[icon]}
      appearance={appearance}
      onClick={onClick}
      disabled={disabled}
    >
      {isNew && (
        <div className="circle-new">
          <div></div>
        </div>
      )}
    </IconButton>
  );
}
